const SELECTOR_TRIGGER = '.js-action-menu-trigger';

const boundTriggers = new WeakSet<HTMLElement>();

function getMenu(trigger: HTMLElement): HTMLElement | null {
  const menuId = trigger.getAttribute('aria-controls');

  if (menuId === null || menuId === '') {
    return null;
  }

  return document.getElementById(menuId);
}

function createActionMenu(trigger: HTMLElement, menu: HTMLElement): void {
  const isOpen = (): boolean => trigger.getAttribute('aria-expanded') === 'true';

  const setOpen = (open: boolean): void => {
    trigger.setAttribute('aria-expanded', String(open));
    menu.dataset.state = open ? 'open' : 'closed';

    if (open) {
      menu.removeAttribute('inert');
    }
    else {
      menu.setAttribute('inert', '');
    }
  };

  trigger.addEventListener('click', () => {
    setOpen(!isOpen());
  });

  document.addEventListener('click', (event) => {
    if (!isOpen()) {
      return;
    }

    const target = event.target as Node | null;

    if (target !== null && (trigger.contains(target) || menu.contains(target))) {
      return;
    }

    setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !isOpen()) {
      return;
    }

    setOpen(false);
    trigger.focus();
  });
}

export function initActionMenu(): void {
  const triggers = document.querySelectorAll<HTMLElement>(SELECTOR_TRIGGER);

  for (const trigger of triggers) {
    const menu = getMenu(trigger);

    if (menu === null || boundTriggers.has(trigger)) {
      continue;
    }

    boundTriggers.add(trigger);
    createActionMenu(trigger, menu);
  }
}
